module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page page-survey container is-fluid"
  }, [_c('div', {
    staticClass: "container container-inner"
  }, [_c('div', {
    staticClass: "columns is-flex is-gapless is-multiline",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticClass: "column is-12 is-mobile-12 content content-main is-right",
    staticStyle: {
      "padding-left": "0.7rem",
      "padding-right": "0.7rem",
      "padding-bottom": "0.2rem"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s('Exit Survey') + "\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "column is-12 is-mobile-12 is-centered"
  }, [(_vm.isSurveyState == null) ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg"
  }, [_c('div', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "0.8em"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isSurveyError) + "\n                  "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "24px"
    }
  }, [_c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("Back to Home")])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.isSurveyState === 'code') ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "box color-gray-lighter-bg"
  }, [_c('div', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "0.8em"
    }
  }, [_vm._v("\n                  " + _vm._s('Survey Code') + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                  Please enter the survey code below.\n                ")]), _vm._v(" "), _c('form-input', {
    attrs: {
      "name": "surveyCode",
      "value": _vm.surveyCode,
      "placeholder": "",
      "error": _vm.surveyError
    },
    on: {
      "onInput": _vm.onSurveyInput
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "control button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function () { return _vm.onSurveyCode(_vm.surveyCode); }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isSurveyState === 'survey') ? _c('div', [(!_vm.submitted) ? _c('form-dynamix', {
    attrs: {
      "type": "team",
      "feedback": _vm.feedback,
      "loading": _vm.loading,
      "names": _vm.names,
      "models": _vm.models,
      "attributes": _vm.attributes,
      "vuelidate": _vm.$v,
      "is-print": _vm.isPrint,
      "is-print-pdf": _vm.isPrintPdf
    },
    on: {
      "recaptcha": _vm.onRecaptcha,
      "send": _vm.onSend
    }
  }) : _vm._e()], 1) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "container navbar-row first is-fluid",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns navbar-full first is-gapless is-mobile"
  }, [_c('div', {
    staticClass: "column navbar-brand",
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "navbar-logo"
  }, [_c('img', {
    staticClass: "img-responsive logo-1",
    attrs: {
      "src": require("../assets/logo.svg"),
      "width": "85"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive logo-2 is-hidden-mobile",
    attrs: {
      "src": require("../assets/logo-text.svg"),
      "width": "360"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container navbar-row second is-fluid",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9479038","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/survey.vue
// module id = 990
// module chunks = 1